import { toast } from "sonner";

// Pull a human-friendly message out of an axios error, falling back sensibly.
export function errorMessage(err, fallback = "Something went wrong") {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string" && detail) return detail;
  if (Array.isArray(detail) && detail[0]?.msg) return detail[0].msg;
  if (err?.message === "Network Error") return "Network error — please check your connection";
  return fallback;
}

// Show a consistent error toast. Also logs to console for support/debugging.
// De-dupes rapid repeats of the same title via a shared toast id.
export function toastError(title, err, opts = {}) {
  if (err) console.error(title, err);
  toast.error(title, {
    id: opts.id || title,
    description: err ? errorMessage(err, opts.fallback) : opts.description,
  });
}
